import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import { Avatar, Box, Container, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../../lang/LangEnum';
import useTeceoStyles from '../../../useTeceoStyles';
import { formatCompleteName } from '../../../utils/formatters';
import { useTranslation } from '../../translation/TranslationContext';
import { Explore } from './myNetworkExplore.types';

type AcceptConnectionModalProps = {
  open: boolean;
  onClose: (success?: boolean) => void;
  brandOrStoreName: string;
  connection: Explore | null;
  onAccept: () => void;
};

const useStyles = makeStyles()((theme) => ({
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
  },
  root: {
    width: '100%',
  },
  container: {
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    right: '50%',
    marginTop: theme.spacing(-3 / 2),
    marginRight: theme.spacing(-3 / 2),
  },
}));

const AcceptConnectionModal = ({
  open,
  brandOrStoreName,
  onClose,
  connection,
  onAccept,
}: AcceptConnectionModalProps) => {
  const { classes } = useStyles();
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();
  const handleClose = () => {
    onClose();
  };

  if (!connection) {
    return null;
  }

  return (
    <Modal
      isOpen={open}
      size="standard"
      header={{ title: translate(LangEnum.ACCEPT_CONNECTION_MODAL_TITLE, { brandOrStoreName }) }}
      onClose={handleClose}
      footer={{
        primaryAction: {
          label: LangEnum.MY_NETWORK_RECEIVED_LIST_ACCEPT,
          onClick: () => onAccept(),
        },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: handleClose },
      }}
    >
      <Container maxWidth="sm" disableGutters>
        <Box>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: 'center',
            }}
          >
            <Grid size={12}>
              <Grid container spacing={1}>
                <Grid size={12}>
                  <Typography color="textSecondary" className={teceoClasses.boldText}>
                    {translate(LangEnum.MY_NETWORK_DETAILS_MODAL_MESSAGE)}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Typography>{connection.invite?.message}</Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid size={12}>
              <Grid container spacing={1}>
                <Grid size={12}>
                  <Typography color="textSecondary" className={teceoClasses.boldText}>
                    {translate(LangEnum.MY_NETWORK_DETAILS_MODAL_CREATED_BY)}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Grid
                    wrap="nowrap"
                    spacing={1}
                    container
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <Grid>
                      <Avatar
                        alt="teceo team"
                        src={connection.invite?.createdBy?.profileUrl}
                        className={classes.avatar}
                      >
                        {connection.invite?.createdBy?.name &&
                          connection.invite?.createdBy?.name[0].toUpperCase()}
                      </Avatar>
                    </Grid>
                    <Grid>
                      <Grid container>
                        <Grid size={12}>
                          <Typography>
                            {formatCompleteName(
                              connection.invite?.createdBy?.name,
                              connection.invite?.createdBy?.surname,
                              '-',
                            )}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography variant="body2" color="textSecondary">
                            {connection.invite?.createdBy?.email}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Modal>
  );
};

export default AcceptConnectionModal;
